import { setupI18n } from '@lingui/core';
import queryString from 'querystring';

export function i18nSetup(catalogs, localeOverride) {
  // get locale from query parameter, default to en-AU
  let locale = localeOverride || getLocale() || 'en-AU';
  if (catalogs[locale] === undefined) {
    locale = 'en-AU';
  }
  return setupI18n({
    language: locale,
    catalogs
  });
}

export function getLocale() {
  const queryParams = window.location.search;
  const query = queryParams.replace('?', '');
  const params = queryString.parse(query);
  return params.locale;
}



// WEBPACK FOOTER //
// ./helpers/locale.js